


















































































































































































































































































































































































































import Vue from 'vue';
import params from '@/Scripts/Params.js';
import names from '@/Scripts/paramsName.js';
import axios from 'axios';
Object.freeze(params);
let vue: any;
function si(id: string) {
    let param = new Object();
    if (Object.prototype.hasOwnProperty.call(params, id)) {
        param = JSON.parse(JSON.stringify(params[id]));
    }
    console.log(param);
    return param;
}
function ai(arg: any) {
    let data = JSON.parse(JSON.stringify(arg));
    if (data['side'] == 'onchart') {
        vue.$emit('addonchart', data);
    } else {
        vue.$emit('addoffchart', data);
    }
    return;
}
const ignoredItem = ['Swap', 'LineTool', 'RangeTool', 'Fibo', 'Parallel_Lines'];
export default Vue.extend({
    name: 'indOvl',
    props: {
        activeSymbol: {
            type: String,
            default: () => {
                return '';
            },
            required: false,
        },
    },
    watch: {
        tab(v) {
            this.saveBox = false;
            this.activeInd = '';
            this.activeIndDescr = '';

            this.activeParams = [];
            this.selectedModel = {};
            this.applyDefaultCheck = false;
            if (v == 'tab-current') {
                this.ignoredItem = 0;
                this.parseModel(v);
                this.tabs.current.data.forEach((el: any) => {
                    if (this.ignoredItemList.indexOf(el.id) != -1) {
                        this.ignoredItem++;
                    }
                });
            }
        },
        activeInd(v) {
            this.saveable = v != '';
        },
        activeSymbol(v) {
            this.parseModel(v);
        },
    },
    beforeMount() {
        vue = this;
        this.parseModel(this.activeSymbol);
    },
    methods: {
        selectInd(id: string) {
            const data = si(id);
            return data;
        },
        selectMInd(id: string) {
            const data = { settings: this.tabs.current.data[id].settings };
            return data;
        },
        addInd() {
            ai(this.activeParams);
            this.activeInd = '';
            this.activeIndDescr = '';
            this.activeParams = [];
            this.$emit('close');
            return;
        },
        loadModel(data: any) {
            window.localStorage.setItem(this.activeSymbol, data);
            this.parseModel(this.activeSymbol);
            this.$emit('load');
        },
        saveCurrent() {
            window.localStorage.removeItem(this.activeSymbol);
            const settings = this.serialiseModel('local');
            window.localStorage.setItem(this.activeSymbol, settings);
            this.saveable = false;
            this.saveable_ovr = false;
            this.activeInd = '';
            this.activeIndDescr = '';
            this.activeParams = [];
            this.$emit('load');
        },

        async upload() {
            return new Promise((resolve, reject) => {
                const settings = this.serialiseModel('upload');
                const token = window.localStorage.getItem('token');
                const id = window.localStorage.getItem('id');
                if (!token || !id) {
                    reject('error');
                } else {
                    const data = { token: token, id: id, model_name: this.modelName, model_data: settings };
                    axios({
                        method: 'post',
                        url: `http://127.0.0.1:8000/api/savemodels`,
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                            'Access-Control-Allow-Origin': '*',
                            'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
                        },
                        data: JSON.stringify(data),
                    })
                        .then((res) => {
                            this.modelName = '';
                            this.saveBox = false;
                            resolve('done');
                        })
                        .catch((err) => {
                            reject('error');
                        });
                }
            });
        },
        save() {
            this.$emit('save');
            this.saveBox = false;
            this.modelName = '';
        },
        removeItem(n: number) {
            if (this.tab == 'tab-current') {
                this.tabs.current.data.splice(n, 1);
                this.saveable = true;
                this.saveable_ovr = true;
                this.activeInd = '';
                this.activeIndDescr = '';
                this.activeParams = [];
            }
        },
        parseModel(symbol: string) {
            if (window.localStorage.getItem(symbol)) {
                const settings = JSON.parse(String(window.localStorage.getItem(symbol))); //reload saved ok
                //this.datas[this.ids[symbol]][this.currentTfId].del('.');
                this.tabs.current.data = [];
                settings.forEach((el) => {
                    if (el['set']['type'] != 'PerfectTrades') {
                        this.tabs.current.data.push({
                            id: el['set']['type'],
                            descr: this.idToDescr(el['set']['type']).descr,
                            icon: this.idToDescr(el['set']['type']).icon,
                            settings: el['set']['settings'],
                            name: el['set']['name'],
                            side: el['side'],
                        });
                    }
                });
                this.loadK += 1;
            }
        },

        serialiseModel(arg: string) {
            let result = [] as any[];
            this.tabs.current.data.forEach((el: any) => {
                if (
                    !(
                        arg == 'upload' &&
                        (el['id'] == 'Swap' ||
                            el['id'] == 'LineTool' ||
                            el['id'] == 'RangeTool' ||
                            el['id'] == 'Fibo' ||
                            el['id'] == 'Parallel_Lines')
                    )
                ) {
                    result.push({
                        side: el['side'],
                        set: {
                            data: [],
                            name: el['name'],
                            settings: el['settings'],
                            type: el['id'],
                        },
                    });
                }
            });
            return JSON.stringify(result);
        },
        idToDescr(id: string) {
            let found = false;
            let result = '' as any;
            for (let i = 0; i < this.tabs.indicators.data.length && !found; i++) {
                if (this.tabs.indicators.data[i].id == id) {
                    found = true;
                    result = { descr: this.tabs.indicators.data[i].descr, icon: this.tabs.indicators.data[i].icon };
                }
            }
            return result;
        },
        paramToName(p: string) {
            if (!(p in names)) {
                return p.toUpperCase();
            } else {
                return names[p];
            }
        },
        setDefault() {
            console.log('done');
            if (this.applyDefault) {
                this.applyDefault = false;
                window.localStorage.removeItem('defaultModel');
                console.log('removed default');
            } else {
                window.localStorage.setItem('defaultModel', JSON.stringify(this.selectedModel));
                this.applyDefault = true;
                console.log('added default');
            }
        },
        checkDefault(model: any) {
            this.selectedModel = model;
            console.log(model);
            const defaultModelData = window.localStorage.getItem('defaultModel');
            if (defaultModelData != null) {
                const defaultModel = JSON.parse(defaultModelData);
                if (defaultModel.id == model.id) {
                    this.applyDefault = true;
                }
            } else {
                this.applyDefault = false;
            }
        },
    },
    beforeDestroy() {
        console.log('close');
    },
    data: () => ({
        ignoredItemList: ignoredItem,
        validate: false,
        saveable: false,
        saveable_ovr: false,
        applyDefaultCheck: false,
        applyDefault: false,
        selectedModel: {} as any,
        ignoredItem: 0,
        loadK: 0,
        activeInd: '',
        loadBox: false,
        saveBox: false,
        modelName: '',
        activeIndDescr: '',
        currentModel: [] as any,
        activeParams: [] as any,
        tabs: {
            indicators: {
                title: 'Indicators',
                data: [
                    { id: 'ALMA', descr: 'Arnaud Legoux Moving Average', icon: 'mdi-chart-multiline' },
                    //{ id: 'Area51', descr: 'Gradient area chart' },
                    { id: 'ATR', descr: 'Average True Range', icon: 'mdi-chart-sankey' },
                    { id: 'ATRp', descr: 'Average True Range Percentage', icon: 'mdi-chart-sankey' },
                    { id: 'BB', descr: 'Bollinger Bands', icon: 'mdi-chart-areaspline' },
                    { id: 'BBW', descr: 'Bollinger Bands Width', icon: 'mdi-chart-sankey' },
                    { id: 'CCI', descr: 'Commodity Channel Index', icon: 'mdi-chart-sankey' },
                    { id: 'CMO', descr: 'Chande Momentum Oscillator', icon: 'mdi-chart-sankey' },
                    { id: 'COG', descr: 'Center of Gravity', icon: 'mdi-chart-sankey' },
                    // { id: 'DHistogram', descr: 'Double Histogram Plot' },
                    { id: 'DMI', descr: 'Directional Movement Index', icon: 'mdi-chart-sankey' },
                    { id: 'EMA', descr: 'Exponential Mooving Average', icon: 'mdi-chart-multiline' },
                    //{ id: 'Histogram', descr: 'Histogram plot' },
                    { id: 'HMA', descr: 'Hull Moving Average', icon: 'mdi-chart-multiline' },
                    { id: 'Ichi', descr: 'Ichimoku Cloud', icon: 'mdi-chart-areaspline' },
                    //{ id: 'Ichimoku', descr: 'Ichimoku' },
                    { id: 'KC', descr: 'Keltner Channels', icon: 'mdi-chart-areaspline' },
                    { id: 'KCW', descr: 'Keltner Channels Width', icon: 'mdi-chart-sankey' },
                    // { id: 'LongShortTrades', descr: 'Long Short Trades' },
                    { id: 'MACD', descr: 'Moving Average Convergence/Divergence', icon: 'mdi-chart-sankey' },
                    //{ id: 'Markers', descr: 'Markers' },
                    //{ id: 'MFI', descr: 'Money Flow Index' },
                    { id: 'MOM', descr: 'Momentum', icon: 'mdi-chart-sankey' },
                    //{ id: 'PlotCross', descr: 'Plot line with crosses' },
                    { id: 'Ribbon', descr: 'Moving Average Ribbon', icon: 'mdi-chart-multiline' },
                    { id: 'ROC', descr: 'Rate of Change', icon: 'mdi-chart-sankey' },
                    { id: 'RSI', descr: 'Relative Strength Index', icon: 'mdi-chart-sankey' },
                    { id: 'SAR', descr: 'Parabolic SAR', icon: 'mdi-chart-timeline-variant-shimmer' },
                    { id: 'SMA', descr: 'Simple Moving Average', icon: 'mdi-chart-multiline' },
                    { id: 'Stoch', descr: 'Stochastic', icon: 'mdi-chart-sankey' },
                    { id: 'SWMA', descr: 'Symmetrically Weighted Moving Average', icon: 'mdi-chart-multiline' },
                    //{ id: 'TradesPlus', descr: 'Trades overlay with stops' },
                    { id: 'TSI', descr: 'True Strength Index', icon: 'mdi-chart-sankey' },
                    //{ id: 'VWMA', descr: 'Volume Weighted Moving Average' },
                    { id: 'WilliamsR', descr: 'Williams %R', icon: 'mdi-chart-sankey' },
                    //{ id: 'XOhlcBars', descr: 'Bar Chart' },
                ],
            },

            current: {
                title: 'Current Template',
                data: [] as any[],
            },
        },
        requiredRules: [(value: any) => !!value || 'Required'],
        modelRules: [(value: any) => !!value || 'Requierd', (value: any) => value.length < 30 || '30 character max.'],
        tab: '',
        widthValues: [0.75, 1, 1.25, 1.5, 2, 3, 4, 5, 6],
        applytoValues: ['open', 'close', 'high', 'low', 'hl2'],
    }),
});
